<template>
  <button v-on="$listeners" class="d-flex align-center justify-center text-uppercase">
    <ArrowSvg />
    <span>{{ $root.allLanguages[$language.current].back }}</span>
  </button>
</template>

<script>
import ArrowSvg from '@/assets/svg/arrow-left.svg'

export default {
  name: 'ButtonBack',
  components: { ArrowSvg }
}
</script>

<style lang="scss" scoped>
button {
  outline: none;
  width: auto;
  height: 64px;
  font-weight: bold;
  transition: all 0.25s ease-in-out !important;

  &:hover {
    opacity: 0.7;
  }

  svg path {
    fill: $c-black;
  }
}
</style>
